
import  gsap from 'gsap';
import  scrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(scrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    const titles = document.querySelectorAll('.section-title')

    if(titles.length < 1) return

    titles.forEach(title => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: title,
            }
        })

        tl.to(title.children, { stagger: 0.1, opacity: 1, translateY: 0 })

        tl.eventCallback('onComplete', () => {
            Array.from(title.children)
                .forEach(child => {
                    child.classList.remove('animate-from-in-up')
                })
        })
    })

}
